import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { generateTestRasterInfo } from 'common/utils/helpers';
import { BeamRankTypes, BUTTON_LOADING_CIRCLE, Status } from 'common/utils/constants';
import { doSetActiveBeam } from 'redux/actions';
import classnames from 'classnames';
import RasterHeatmap from 'components/features/RasterHeatmap/RasterHeatmap';
import CommissionErrorBox from '../CommissionErrorBox/CommissionErrorBox';
import './CommissionBeamSelectionScreen.css';
import { SCREEN_INDEXES } from '../utils';

const CommissionBeamSelectionScreen = (props) => {
  const dispatch = useDispatch();
  let [azElInputError, setAzElInputError] = useState({ az: null, el: null });
  let [selectedBeamRankIndex, setSelectedBeamRankIndex] = useState(1);
  let [customAzEl, setCustomAzEl] = useState({ az: null, el: null });
  let beamrank = useSelector((store) => store.data.heatmap.beamrank);

  let setActiveBeamStatusName = `setActiveBeam-${props.commissioningId}`;
  let setActiveBeamStatus = useSelector((store) => store.statuses[setActiveBeamStatusName]);

  // test raster info, not sure if this will be coming from a certain commissioning API
  let testRasterInfo = generateTestRasterInfo();
  const [donorDevice, ...serviceDevices] = props.selectedDevices;

  const handleOnNext = () => {
    let cb_success = () => {
      const isHBFServiceExist = serviceDevices.find(service => service.productType === 'HBF_SERVICE');

      if (isHBFServiceExist) {
        props.setScreenIndex(SCREEN_INDEXES.HBF_SERVICE);
      } else {
        props.onNext(SCREEN_INDEXES.SELECT_BEAM, null);
      }
    };

    // set active beam
    let azEl = { azimuth: null, elevation: null };
    if (beamrank) {
      if (selectedBeamRankIndex !== 4) {
        azEl.azimuth = beamrank[selectedBeamRankIndex - 1].az;
        azEl.elevation = beamrank[selectedBeamRankIndex - 1].el;
      } else {
        azEl.azimuth = customAzEl.az;
        azEl.elevation = customAzEl.el;
      }
    }

    if (azEl.azimuth !== null && azEl.elevation !== null && props.commissioningId) {
      dispatch(doSetActiveBeam(props.commissioningId, azEl, cb_success));
    }
  };

  let setActiveBeamErrorBox = null;
  if (setActiveBeamStatus === Status.FAILURE) {
    setActiveBeamErrorBox = (
      <CommissionErrorBox
        title={'Set active beam error'}
        message={'Something went wrong. Please try again later.'}
        onClose={props.onClose}
      />
    );
  }

  return (
    <div className="CommissionBeamSelectionScreen_Container">
      {setActiveBeamErrorBox && setActiveBeamErrorBox}
      <div className={'CommissionBeamSelectionScreen_TopDiv'}>
        <div className="CommissionBeamSelectionScreen_TopDiv_Text">Beam selection</div>
      </div>
      <div className={'CommissionBeamSelectionScreen_HeatMapDiv'}>
        <RasterHeatmap
          id={donorDevice ? donorDevice.deviceId : null}
          rasterInfo={testRasterInfo}
          azElInputError={azElInputError}
          setAzElInputError={setAzElInputError}
          selectedBeamRankIndex={selectedBeamRankIndex}
          setSelectedBeamRankIndex={setSelectedBeamRankIndex}
          customAzEl={customAzEl}
          setCustomAzEl={setCustomAzEl}
        />
      </div>
      <div className={'CommissionBeamSelectionScreen_BottomContainer'}>
        <button
          className="CommissionBeamSelectionScreen_CancelButton"
          onClick={() => {
            props.clearTimeoutAndInterval();
            props.onClose();
          }}
          disabled={setActiveBeamStatus === Status.PENDING}
        >
          Cancel
        </button>
        <button
          type="submit"
          className={classnames({
            CommissionBeamSelectionScreen_NextButton: true,
            CommissionBeamSelectionScreen_NextButton_Disabled:
              selectedBeamRankIndex === 4 &&
              (azElInputError.az !== null ||
                azElInputError.el !== null ||
                customAzEl.az === null ||
                customAzEl.el === null ||
                customAzEl.az === '' ||
                customAzEl.el === '')
          })}
          onClick={() => {
            handleOnNext();
          }}
        >
          {setActiveBeamStatus === Status.PENDING ? BUTTON_LOADING_CIRCLE : 'Next'}
        </button>
      </div>
    </div>
  );
};

export default CommissionBeamSelectionScreen;
